import { Link } from 'react-router-dom';
import { JsonLd } from '../JsonLd';
import { SITE_URL } from '../SEO';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

function buildBreadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.label,
      ...(item.href ? { item: `${SITE_URL}${item.href}` } : {}),
    })),
  };
}

export function Breadcrumb({ items }: BreadcrumbProps): JSX.Element {
  return (
    <>
      <JsonLd data={buildBreadcrumbSchema(items)} />
      <nav aria-label="Breadcrumb" className="mb-6">
        <ol className="flex items-center gap-2 text-sm text-[var(--landing-text-muted)]">
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-2">
              {i > 0 && (
                <span aria-hidden="true" className="text-[var(--landing-border)]">/</span>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-[var(--landing-text-primary)] transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-[var(--landing-text-secondary)]">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
